import { ComponentController } from './component-controller.class';
import { ControllerNodeBase, ControllerNodeOptions, Publish } from '@rta/rta-blueprint-library';

import { DisplayMode } from './enums';
import { NavigationDataIn } from './types';
import { navigationDefaults } from './defaults/navigation-defaults';

export class Navigation extends ControllerNodeBase<NavigationDataIn> {
	#controller: ComponentController;
	#displayMode: DisplayMode;
	#islandId: string | null;
	#panelId: string | null;

	readonly panelPrevId: string | null;
	readonly xScale: number;

	public activeRef: string;
	public xScaleFactor: number;
	public yScaleFactor: number;

	constructor (options: ControllerNodeOptions<NavigationDataIn>, controller: ComponentController) {
		super('navigation', options);
		const initOptions = {
			...navigationDefaults,
			...options
		};

		this.#controller = controller;
		this.#islandId = null;
		this.#panelId = null;

		// all options should be public
		Object.keys(initOptions)
			.forEach((key) => {
				this[key] = initOptions[key];
			});

		this.setInitialized();
	}

	@Publish('navigation-display-mode', 'updated')
	set displayMode (mode: DisplayMode) {
		this.#displayMode = mode;
		const isSkuOverhead = mode === DisplayMode.SkuOverhead || mode === DisplayMode.SkuOverheadManufacturing;
		if (this.#controller?.options) {
			this.#controller.options.dimensionFontSizeFactor = isSkuOverhead ? 1.4 : 1.2;
		}
	}
	get displayMode (): DisplayMode { return this.#displayMode; }

	get panelId (): string | null {
		// if (this.#panelId === null && this.#controller) {
		// 	this.#panelId = this.#controller.kitchen.design.islands.findById(this.islandId ?? '')?.frontPanel.id ?? null;
		// }
		// console.log('panelId', this.#panelId);
		return this.#panelId;
	}
	@Publish('navigation-panel', 'updated')
	set panelId (id: string | null) {
		if (this.#controller && id !== null) {
			const panel = this.#controller.kitchen.design.islands.findById(this.#islandId ?? '')?.panels.findById(id);
			if (panel) this.#panelId = id;
		} else {
			this.#panelId = null;
		}
	}

	get islandId (): string | null {
		if (this.#islandId === null && this.#controller) {
			const island = this.#controller.kitchen?.design.islands.getDefaultIsland();
			this.#islandId = island?.id ?? null;
			this.#panelId = island?.frontPanel.id ?? null;
		}
		// console.log('islandId', this.#islandId);
		return this.#islandId;
	}
	@Publish('navigation-island', 'updated')
	set islandId (id: string | null) {
		if (this.#controller) {
			const island = this.#controller.kitchen?.design.islands.findById(id ?? '');
			if (island) {
				this.#islandId = id;
				this.#panelId = island?.frontPanel.id ?? null;
			}
		}
	}
}

